import { ReactElement, cloneElement } from 'react';

import { Control, Controller } from 'react-hook-form';

interface FormControllerProps {
  name: string;
  control: Control<any>;
  children: ReactElement;
}

const FormController = ({ name, control, children }: FormControllerProps) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { ref, ...rest }, fieldState }) =>
        cloneElement(children, {
          ...rest, // Spread form field props first
          ...children.props, // Then spread original props to preserve them
          checked: rest.value,
          ref: ref,
          error: fieldState.error
            ? Array.isArray(fieldState.error)
              ? fieldState.error[0]?.message // if an array, we show the first message only. TODO: show all messages.
              : fieldState.error?.message
            : undefined,
          key: name
        })
      }
    />
  );
};

export { FormController };
